export default "__VITE_ASSET__DiBpXBmb__"